module.exports = __webpack_public_path__ + "static/powerful.79e00f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/powerful.jpg
// module id = 480
// module chunks = 59963396046441